import { useState, useEffect } from 'react';

const C = { bg: '#050a0e', surface: '#0b1318', border: '#1a3040', accent: '#00e5ff', muted: '#5a8a9f', mono: "'Space Mono', monospace" };
const links = [
  { href: '#about', label: 'About' },
  { href: '#skills', label: 'Skills' },
  { href: '#projects', label: 'Projects' },
  { href: '#experience', label: 'Expérience' },
  { href: '#candidature', label: 'Candidature' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, width: '100%', zIndex: 100,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '1.2rem 3rem',
      background: scrolled ? 'rgba(5,10,14,0.97)' : 'rgba(5,10,14,0.75)',
      backdropFilter: 'blur(14px)',
      borderBottom: `1px solid ${C.border}`,
      transition: 'background 0.3s',
    }}>
      <span style={{ fontFamily: C.mono, fontSize: '0.9rem', color: C.accent, letterSpacing: '0.1em' }}>
        CK.portfolio
      </span>
      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
        {links.map(l => (
          <a key={l.href} href={l.href}
            style={{ fontFamily: C.mono, fontSize: '0.72rem', color: C.muted, textDecoration: 'none', letterSpacing: '0.12em', textTransform: 'uppercase', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = C.accent}
            onMouseLeave={e => e.target.style.color = C.muted}>
            {l.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
